import variationsFor from './variationsFor'

const types = {
  SAVE_ACCOUNT: 'SAVE_ACCOUNT',
  ...variationsFor('GET_ACCOUNT'),
  ...variationsFor('UPDATE_ACCOUNT')
}

export default types
